import { Component, inject, computed } from '@angular/core';
import {SessionService} from "~core/services/session.service";
import {isLanguageCode} from "~core/types/language.type";


@Component({
  selector: 'app-language-selector',
  imports: [],
  templateUrl: './language-selector.component.html',
  standalone: true,
})
export class LanguageSelectorComponent {
  sessionService= inject(SessionService);


  get languages() {
    return this.sessionService.getLanguages();
  }

  get currentLang() {
    return this.sessionService.CurrentLanguage;
  }
  setLang(code: string) {
    if (isLanguageCode(code)) {
      this.sessionService.setCurrentLanguage(code)
    }
  }
}
